import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { ListRequestQuery, WSServiceError } from "../../utils/serviceHelper";
import { getPlanEnrollments } from "../../services/api/planEnrollment/getPlanEnrollments";
import {
  IPlanEnrollment,
  IPlanEnrollmentListQueryFilter,
  IPlanEnrollmentListQuerySort
} from "../../services/api/planEnrollment/types";

export const QUERY_BENEFITS_PLAN_ENROLLMENTS =
  "QUERY_BENEFITS_PLAN_ENROLLMENTS";

export const usePlanEnrollments = (
  params: ListRequestQuery<
    IPlanEnrollmentListQueryFilter,
    IPlanEnrollmentListQuerySort
  >,
  config?: WSQueryConfig<IPlanEnrollment[], WSServiceError>
) =>
  useWSQuery(
    [QUERY_BENEFITS_PLAN_ENROLLMENTS, params],
    () => getPlanEnrollments(params),
    config
  );
